export abstract class BaseUrlSearchBuilder {
    protected setFileType = (isFile: boolean) => {
        // return isFile ? "(isDocument=true OR size>0)" : "contentTypeId:0x0120*"
        return isFile ? "-contentTypeId:0x0120*" : "contentTypeId:0x0120*"
    }
}